import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { rootUrl } from '../../config/config';
import { useAuth } from '../../components/myTrack/AuthContext';

export default function PermissionsPage() {
    const { token, user } = useAuth();
    const [permissions, setPermissions] = useState([]);
    const [editing, setEditing] = useState({ key: '', name: '', description: '' });
    const headers = { Authorization: `Bearer ${token}` };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { fetchAll(); }, []);

    async function fetchAll() {
        try {
            const r = await axios.get(`${rootUrl}/api/permissions`, { headers });
            setPermissions(r.data.data || []);
        } catch (err) { console.error(err); }
    }

    async function save() {
        try {
            await axios.post(`${rootUrl}/api/permissions`, { ...editing, input_by: user?.username }, { headers });
            setEditing({ key: '', name: '', description: '' });
            fetchAll();
        } catch (err) { console.error(err); }
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-[#fff8f5] to-[#EDE4DA]">
            <div className="p-6 lg:p-8 text-center mb-8">
                <h1 className="text-4xl font-bold text-[#2a2e30] mb-2">Permissions</h1>
                <div className="w-24 h-1 bg-[#FF5733] mx-auto rounded-full mb-4"></div>
                <p className="text-lg text-[#2a2e30] opacity-80">Create and manage permission keys</p>
            </div>
            <div className="w-full max-w-7xl mx-auto px-2 sm:px-4 pb-8">
                <div className="bg-white rounded-2xl shadow-xl p-6">
                    <div className="mb-4 flex justify-between">
                        <div />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <h3 className="font-semibold mb-2">Existing Permissions</h3>
                            <div className="space-y-2">
                                {permissions.map(p => (
                                    <div key={p.id} className="border p-2 rounded flex justify-between items-center">
                                        <div>
                                            <div className="font-medium">{p.key}</div>
                                            <div className="text-sm text-gray-600">{p.name} — {p.description}</div>
                                        </div>
                                        <div className="text-sm text-gray-500">ID: {p.id}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div>
                            <h3 className="font-semibold mb-2">Create Permission</h3>
                            <label className="block">Key</label>
                            <input className="w-full p-2 border rounded" value={editing.key} onChange={e => setEditing({ ...editing, key: e.target.value })} />
                            <label className="block mt-3">Name</label>
                            <input className="w-full p-2 border rounded" value={editing.name} onChange={e => setEditing({ ...editing, name: e.target.value })} />
                            <label className="block mt-3">Description</label>
                            <input className="w-full p-2 border rounded" value={editing.description} onChange={e => setEditing({ ...editing, description: e.target.value })} />
                            <div className="mt-4">
                                <button onClick={save} className="bg-[#FF5733] hover:bg-[#e64520] text-white text-sm font-semibold rounded-sm px-3 py-1 mr-2">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
